import React from 'react';
import { Route } from 'react-router-dom';
import history from 'app/routes/history';
import FullModal from 'app/components/layout/FullModal';

import * as authenticationSelectors from 'app/ducks/authentication/selectors';
import AuthenticatedComponent from '../AuthenticatedComponent';

interface IPrivateRouteProps {
  component: any;
  fullModal: boolean;
  actions: any;
  path: any;
  exact?: boolean;
  isModal?: boolean;
  previousPath?: any;
}

const refreshOrLogoutUser = (refreshOrLogoutUserAction) => {
  const currentLocation = history.location.pathname;
  refreshOrLogoutUserAction(currentLocation, true);
};

const checkAuth = async (rest) => {
  const authenticated = await authenticationSelectors.isAuthenticated();
  if (!authenticated) {
    refreshOrLogoutUser(rest.actions.refreshOrLogoutUser);
  }
  return authenticated;
};

const PrivateRoute = ({
  component: Component,
  ...rest
}: IPrivateRouteProps): React.ReactNode => {
  const authenticated = checkAuth(rest) || false;
  return (
    <Route
      {...rest}
      render={(props) => {
        if (authenticated) {
          props.match.isModal = rest.fullModal || false;
          props.match.previousPath = rest.previousPath || undefined;
          if (rest.fullModal) {
            return (
              <AuthenticatedComponent {...props}>
                <FullModal isModal={rest.isModal}>
                  <Component {...props} isModal={rest.isModal} />
                </FullModal>
              </AuthenticatedComponent>
            );
          }
          return (
            <AuthenticatedComponent {...props}>
              <Component {...props} />
            </AuthenticatedComponent>
          );
        }
        return (<div />);
      }}
    />
  );
};

export default PrivateRoute;
